import { Header } from '@fhs-legacy/universal-components';

export const CartItemName = Header.withConfig({
  variant: 'headerThree',
  margin: 0,
});

export default CartItemName;
